// extracted by mini-css-extract-plugin
module.exports = {"headerButton":"downloadAllSpecificationsButton_headerButton__2XREI","downloadAllButton":"downloadAllSpecificationsButton_downloadAllButton__3fSYy"};